"use strict";
(function (BodyOutputType) {
    BodyOutputType[BodyOutputType["Default"] = 0] = "Default";
    BodyOutputType[BodyOutputType["TrustedHtml"] = 1] = "TrustedHtml";
    BodyOutputType[BodyOutputType["Component"] = 2] = "Component";
})(exports.BodyOutputType || (exports.BodyOutputType = {}));
var BodyOutputType = exports.BodyOutputType;
//# sourceMappingURL=bodyOutputType.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2-toaster/lib/bodyOutputType.js
 ** module id = 74
 ** module chunks = 0
 **/